import { api } from './client';

export const dashboardApi = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  getRecentAlarms: async (limit?: number) => {
    const response = await api.get('/dashboard/recent-alarms', {
      params: { limit },
    });
    return response.data;
  },
};
